import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import Grid from '@material-ui/core/Grid';

class Info extends React.Component {
    state = {
        id: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.forecast && (props.forecast !== state.forecast || props.id !== state.id)) {
            const { fecha, nLocal, importemix } = props.info;

            state.forecast = props.forecast;
            state.id = props.id;
            state.fecha = fecha ? fecha : '';
            state.nLocal = nLocal ? nLocal : '';
            state.importemix = importemix ? importemix : '';

            return state;
        }
        return null;
    }

    render() {
        const { fecha, nLocal, importemix } = this.state;
        const { intl } = this.props;
        return (
            <Card className={'production_total_card'}>
                <CardContent>
                    <Grid container className={'flex_grow_1 margin_top_8'}>
                        <Grid item xs={4} className="">
                            <div className="barlowsemicondensed_bold c_dark_grey_blue text_align_left">
                                {nLocal}
                            </div>
                        </Grid>
                        <Grid item xs={4} className="align_center display_flex center">
                            <div className="barlow_medium c_dark_grey_blue text_align_left">
                                {fecha}
                            </div>
                        </Grid>
                        <Grid item xs={4} className="align_center display_flex text_align_end">
                            <div className="barlow_medium c_dark_grey_blue ">
                                {intl.formatMessage({ id: 'units' }) + ' / ' + importemix + ' €'}
                            </div>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

Info.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Info);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecast/Info.js